// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"PQ-z","categoryName":"QQ-z","categoryNameSearchHeader":"RQ-z","categoryContent":"SQ-z","bottomAligned":"TQ-z","image":"UQ-z","imageNoBackground":"VQ-z"};